import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../styles/WelcomeScreen.css';

function WelcomeScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'MOA4CUTS';
    document.body.style.overflow = 'auto';

    const preloadImages = [
      '/img/LLMember/SB.png', '/img/LLMember/YJ.png', '/img/LLMember/BG.png',
      '/img/LLMember/TH.png', '/img/LLMember/HK.png',
      '/img/TMRWMember/SB.png', '/img/TMRWMember/YJ.png', '/img/TMRWMember/BG.png',
      '/img/TMRWMember/TH.png', '/img/TMRWMember/HK.png',
      '/img/Ppulbatu/Bamgeut.png', '/img/Ppulbatu/Dagonyang.png', '/img/Ppulbatu/Hmmnyaring.png',
      '/img/Ppulbatu/Hwangchoon.png', '/img/Ppulbatu/Yongmeong.png',
    ];
    preloadImages.forEach((src) => { new Image().src = src; });

    return () => {
      document.body.style.overflow = '';
    };
  }, []);  

  const goToPhotoBooth = (boothType) => {
    if (boothType === 'LLMember') {
      navigate('/frame-selection/LLMember');
    } else if (boothType === 'TMRW') {
      navigate('/frame-selection/TMRWMember');
    } else if (boothType === 'Ppulbatu') {
      navigate('/frame-selection/Ppulbatu');
    } else {
      navigate(`/photobooth/${boothType}`);
    }
  };

  return (
    <div className="WelcomeScreen">
      <div className="booth-options">


        {/* Ppulbatu Box */}
        <div className="booth-box booth-box-Ppulbatu" onClick={() => goToPhotoBooth('Ppulbatu')}>
          <div className="photo-frame">
            <img
              src="/img/ppulbatu.png"
              alt="Ppulbatu Booth"
              className="booth-image"
            />
          </div>
          <button onClick={() => goToPhotoBooth('Ppulbatu')} className="booth-button booth-button-overlay">
            <span>Ppulbatu</span>
            <span className="arrow">{'>'}</span>
          </button>
        </div>

        {/* TOMORROW Box - Image fills container, button overlaid */}
        <div className="booth-box booth-box-TMRW"   onClick={() => goToPhotoBooth('TMRW')}>
          <div className="photo-frame">
            <img 
              src="/img/TMRWMemberBooth.png" 
              alt="Tomorrow Booth" 
              className="booth-image" 
            />
          </div>
          <button onClick={() => goToPhotoBooth('TMRW')} className="booth-button booth-button-overlay">
            <span>The Star Chapter: TOGETHER</span>
            <span className="arrow">{'>'}</span>
          </button>
        </div>

        {/* Love Language Member Box */}
        <div className="booth-box booth-box-LLMember">
          <div className="photo-frame">
            <img 
              src="/img/LLMemberBooth.png" 
              alt="Love Language" 
              className="booth-image" 
            />
          </div>
          <button onClick={() => goToPhotoBooth('LLMember')} className="booth-button">
            <span>Love Language</span>
            <span className="arrow">{'>'}</span>
          </button>
        </div>

        {/* Love Language Original frame */}
        {/*
        <div className="booth-box">
          <div className="photo-frame">
            <img 
              src="img/LoveLanguage.jpeg" 
              alt="Love Language Original Frame" 
              className="booth-image" 
            />
          </div>
          <button onClick={() => goToPhotoBooth('LLOriginalFrame')} className="booth-button">
            <span>Love Language Original Frame</span>
            <span className="arrow">{'>'}</span>
          </button>
        </div>
        */}

        {/* Ppulbatu heart + clover */}
        {/*
        <div className="booth-box disabled">
          <div className="photo-frame">
            <img 
              src="/img/ppulbatu_actpromise.png" 
              alt="Landscape Booth" 
              className="booth-image" 
            />
          </div>
          <button className="booth-button" disabled>
            <span>Ppulbatu Angel / Clover frame
            </span>
            <span className="arrow">{'>'}</span>
          </button>
          <div className="coming-soon-overlay">Coming Soon</div>
        </div>
        */}
      </div>
    </div> 
  );
}

export default WelcomeScreen;